import React from 'react'
import { useSelector } from 'react-redux'
import { makeStyles, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core'
import ContentGroupTableRow from './GroupTableRow'

const passesSearchFilter = (toCheck, filter) => {
  if (!filter) return true
  if (toCheck.toLowerCase().includes(filter.toLowerCase())) return true
  return false
}

const useStyles = makeStyles(theme => ({
  noContentGroupsContainer: {
    backgroundColor: 'rgb(230,230,230)',
    padding: '1rem'
  },
  headingCell: {
    textAlign: 'center',
    borderRight: '1px solid rgba(0,0,0,0.1)'
  }
}))

const NoContentGroups = () => {
  const classes = useStyles()
  return <div className={classes.noContentGroupsContainer}>
    No Content Groups Created
  </div>
}

const GroupsTable = props => {
  const { selectGroup, searchFilter } = props
  const { contentGroups } = useSelector(state => state.data)

  const classes = useStyles()
  const groupRows = []
  contentGroups.forEach((contentGroup, i) => {
    if (passesSearchFilter(contentGroup.Group.groupName, searchFilter)) {
      groupRows.push(
        <ContentGroupTableRow
          contentGroup={contentGroup}
          selectGroup={selectGroup}
          key={'contentGroup' + i}
        />
      )
    }
  })

  return <Paper>
    {
      groupRows.length ? <Table>
        <TableHead>
          <TableRow>
            <TableCell className={classes.headingCell}>
              Name
            </TableCell>
            <TableCell className={classes.headingCell}>
              Description
            </TableCell>
            <TableCell className={classes.headingCell}>
              Categories
            </TableCell>
            <TableCell className={classes.headingCell}>
              Users
            </TableCell>
            <TableCell padding="checkbox" />
          </TableRow>
        </TableHead>
        <TableBody>
          {groupRows}
        </TableBody>
      </Table> : <NoContentGroups />
    }
  </Paper>
}

export default GroupsTable
